import React from 'react';
import RedirectIndex from '../components/RedirectIndex';

const Page = () => <RedirectIndex />;

Page.noLayout = true;

export default Page;
